import { gql } from "@apollo/client";

import { DashboardGoalFragment } from "./dashboard-goal-fragment";

export default gql`
  ${DashboardGoalFragment}
  query getDashboardGoalsNewPageQuery(
    $owners: [Int]
    $contributors: [Int]
    $goalInvolvingUsers: [Int]
    $teamGoalsOfUser: Int
    $forUserId: Int!
    $fetchData: Boolean!
    $goalStates: [GoalState]!
    $goalScopes: [GoalScope]
    $goalDueBetweenDates: [Date]
    $orderBy: String
    $after: String
  ) {
    goalsForUser(
      goalOwners: $owners
      goalContributors: $contributors
      goalInvolvingUsers: $goalInvolvingUsers
      teamGoalsOfUser: $teamGoalsOfUser
      goalStates: $goalStates
      goalScopes: $goalScopes
      goalDueBetweenDates: $goalDueBetweenDates
      forUserId: $forUserId
      first: 10
      orderBy: $orderBy
      after: $after
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
      edges @include(if: $fetchData) {
        node {
          ...DashboardGoalFragment
        }
      }
    }
  }
`;
